export default function Main({ children }) {
  return <main className="py-16">{children}</main>;
}
